import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
export function Decision() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-179" data-mp="1r27mbva2c159">
      <div className="mx-auto max-w-2xl" data-id="element-180" data-mp="1r3qyb9oorq18">
        <SectionHeading kicker="Your purchase, your decision" title="Make an informed decision about your clinical education." data-id="element-181" data-mp="1w0hfk0c88ro8" />
        <div className="mt-8 space-y-4 text-lg leading-relaxed text-ink" data-id="element-182" data-mp="2joik6y6abnyd">
          <p data-id="element-183" data-mp="2ooddf8dj8pml">I want you to know exactly what you’re purchasing.</p>
          <p data-id="element-184" data-mp="2aqgdq33s833p">
            <strong data-id="element-185" data-mp="2aovh87xwqa37">ALOPECIA CLINICAL BLUEPRINT™</strong> is a digital educational reference
            collection. It is designed to support professional learning, structured information
            review, and educational documentation.
          </p>
          <p data-id="element-186" data-mp="zd4ek5iyw8nv">
            The 15-minute framework refers to a proposed workflow for organizing an initial review of
            available information.
          </p>
          <p className="text-ink-muted" data-id="element-187" data-mp="jxatcecc6l0d">
            It does not replace a complete patient consultation, clinical examination, diagnostic
            investigations, professional judgment, or appropriate referral.
          </p>
        </div>

        <div className="mt-8 flex items-start gap-4 rounded-3xl bg-success-soft p-5" data-id="element-188" data-mp="ovvjtm1sdqbm">
          <ShieldCheckIcon className="h-10 w-10 shrink-0 text-success" aria-hidden="true" data-id="element-189" data-mp="oy8aqopivb0t" />
          <div data-id="element-190" data-mp="12tk1kl0k4hcg">
            <h3 className="font-display text-2xl font-extrabold uppercase text-ink" data-id="element-191" data-mp="xwjy8hv3dsp1">Refund policy</h3>
            <p className="mt-1 leading-relaxed text-ink" data-id="element-192" data-mp="1clgciwnqs1y3">
              Review the applicable eligibility requirements, request procedure, and deadline
              displayed at checkout.
            </p>
          </div>
        </div>

        <CTAButton className="mt-10" label="Get the complete collection for $27" note="One-time payment · Secure checkout" data-id="element-193" data-mp="1ln6545td16xg" />
      </div>
    </section>;
}